let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dixem")).then(() => parcelRequire('9kCFr'));